import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";
import { AdminRole } from "../types";

export type UpdateAdminParams = {
  id: string;
  roles: AdminRole[];
};

const updateAdmin = async (params: UpdateAdminParams): Promise<void> => {
  const fn = httpsCallable<UpdateAdminParams, void>(functions, "updateAdmin");
  await fn(params);
};

export default updateAdmin;
